const createStringLabels = textBefore => {
  const lastSingleQuoute = textBefore.lastIndexOf("'")
  const lastDoubleQuoute = textBefore.lastIndexOf('"')
  const numberOfSingleQuote = textBefore.split("'").length - 1
  const numberOfDoubleQuote = textBefore.split('"').length - 1

  if (0 === numberOfSingleQuote % 2 && 0 === numberOfDoubleQuote % 2) {
    return ["'", '"']
  }

  if (-1 === lastSingleQuoute && -1 === lastDoubleQuoute) {
    return ["'", '"']
  }

  if (lastSingleQuoute > lastDoubleQuoute && 1 === numberOfSingleQuote % 2) {
    return ["'"]
  }

  if (lastSingleQuoute < lastDoubleQuoute && 1 === numberOfDoubleQuote % 2) {
    return ['"']
  }

  return []
}

export const TOKENS_CAN_BE_COMPLETED = [
  'TOKEN',
  'NTOKEN',
  'ATOKEN',
  'ERROR',
  'BREF',
  'NREF',
  'TRAIT',
  'NTRAIT',
  'ATRAIT',
  'LIKE',
  'AND',
  'OR',
  'IN',
  'IN_SHAPE',
  'IN_SECTION',
  'NOT',
  'NOT_IN',
  'CODEBOOK_IN',
  'CODEBOOK_EQ',
  'CODEBOOK_NEQ',
  'TAG_IN',
  'TAG_EQ',
  'TAG_NEQ',
  'MAX',
  'MAXPOS',
  'MAXPOSITION',
  'MIN',
  'MINPOS',
  'MINPOSITION',
  'COUNT',
  'TAG'
]

export const TOKENS_OPERATOR_LABELS = {
  LIKE: 'like',
  AND: 'and',
  OR: 'or',
  IN: 'in',
  IN_SHAPE: 'in cluster',
  IN_SECTION: 'in section',
  NOT: 'not',
  NOT_IN: 'not in',
  CODEBOOK_IN: 'codebook_in',
  CODEBOOK_EQ: 'codebook_eq',
  CODEBOOK_NEQ: 'codebook_neq',
  TAG_IN: 'tag_in',
  TAG_EQ: 'tag_eq',
  TAG_NEQ: 'tag_neq',
  MAX: 'max',
  MAXPOS: 'maxposition',
  MAXPOSITION: 'maxposition',
  MIN: 'min',
  MINPOS: 'minposition',
  MINPOSITION: 'minposition',
  COUNT: 'count',
  // string
  STR: createStringLabels,
  // compare
  EQ: '=',
  NEQ: '!=',
  LE: '<=',
  GE: '>=',
  LT: '<',
  GT: '>',
  // math
  MLT: '*',
  DIV: '/',
  ADD: '+',
  SUB: '-',
  // other
  COMMA: ',',
  LPAREN: '(',
  RPAREN: ')'
}
